module.exports = "/lucky-balls/img/infobox/info_Box_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_008.png
// module id = 1073
// module chunks = 0